const useGetCountryListDto = async (
  variables?: GetCountryListQueryVariables,
  options?: GraphqlQueryOptions<GetCountryListQuery, GetCountryListQueryVariables>,
) => {
  const query = await useGraphqlQuery(GetCountryListSchema, variables, options);
  const list = computed(() => query.result.value?.info?.countries?.list ?? null);

  return {
    ...query,
    list,
  };
};

export { useGetCountryListDto };
